import React from 'react'
import { Outlet, Route } from 'react-router'
import AccountSettingProvider from '@/modules/settings/components/tax-settings/services/account-setting-provider'
const DocumentExport = React.lazy(() => import('@/modules/document-export/document-export'))

const documentExportRoutes = (
  <>
    <Route Component={() => <AccountSettingProvider><Outlet /></AccountSettingProvider>}>
      <Route path='document-export/:hash?' Component={DocumentExport} />
    </Route>
  </>
)

export default documentExportRoutes
